module.exports = __webpack_public_path__ + "static/media/Danil Nagy.1a40c3d1.png";